import { useField, useFormikContext } from 'formik';
import React from 'react';

import styled from '@emotion/styled';

import RadioArrowRight from '../Icons/RadioArrowRight';
import RadioMarkIcon from '../Icons/RadioMarkIcon';
import { FieldErrorInfo } from './FormField';

interface CustomRadioGroupProps {
  children: React.ReactNode;
  name: string;
  className?: string;
}

export const CustomRadioGroup: React.FC<CustomRadioGroupProps> = ({
  children,
  name,
  className,
}) => {
  const { errors, touched } = useFormikContext<any>();

  return (
    <RadioGroup>
      {React.Children.map(children, (child: any) => {
        return React.cloneElement(child, {
          ...child.props,
        });
        // }
      })}

      {errors[name] && touched[name] ? (
        <CustomFieldErrorInfo className={className}>
          {(errors as any)[name].capitalize()}
        </CustomFieldErrorInfo>
      ) : null}
    </RadioGroup>
  );
};

export interface CustomRadioProps {
  label?: any;
  id?: string;
  name: string;
  children?: any;
  className?: string;
  value?: string;
}

export const CustomRadio: React.FC<CustomRadioProps> = ({
  children,
  className,
  ...props
}) => {
  const [field] = useField({ ...props, type: 'radio' });

  return (
    <RadioWrapper className={className}>
      <label>
        <input type='radio' {...field} {...props} />
        <RadioItemDiv>
          {children}
          <RadioItemActiveIcon className='active'>
            <RadioMarkIcon />
          </RadioItemActiveIcon>
          <RadioItemInactiveIcon className='inactive'>
            <RadioArrowRight />
          </RadioItemInactiveIcon>
        </RadioItemDiv>
      </label>
    </RadioWrapper>
  );
};

const RadioItemDiv = styled.div`
  display: flex;
  border: 1px solid ${({ theme }) => theme.palette.borderColor};
  padding: 20px;
  width: 100%;
  border-radius: 8px;
  justify-content: space-between;
  align-items: center;
  font-weight: 500;
  height: 59px;
`;

const RadioItemActiveIcon = styled.div`
  display: none;
`;

const RadioItemInactiveIcon = styled.div``;

const RadioWrapper = styled.div`
  & > label {
    width: 100%;
    display: grid;

    & > * {
      grid-column: 1;
      grid-row: 1;
    }
  }

  & > label input[type='radio'] {
    visibility: hidden;
  }

  & > label input[type='radio']:checked ~ div {
    font-weight: 700;
    color: ${({ theme }) => theme.palette.blueColor};
  }

  & > label input[type='radio']:checked ~ div > .active {
    display: block;
  }

  & > label input[type='radio']:checked ~ div > .inactive {
    display: none;
  }

  & > label input[type='radio']:checked ~ div {
    border: 1px solid ${({ theme }) => theme.palette.blueColor};
    background-color: ${({ theme }) =>
      theme.palette.logiFormBackgroundHighlight};
  }

  & > * {
    cursor: pointer;
  }
`;

const RadioGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  & > * {
  }
`;

const CustomFieldErrorInfo = styled(FieldErrorInfo)`
  margin-top: 12px;
  margin-left: 12px;

  &.slim-error {
    margin-top: 0px;
    margin-left: 0px;
  }
`;
